import React from 'react';
import './Legal.css';
import Header from '../Shared/Header/Header';
import Footer from '../Shared/Footer/Footer';
import SubHeader from '../Shared/SubHeader';

const Terms = () => {
    return (
        <>
            <Header />
            <SubHeader title="Terms and Conditions" subtitle="Please read these terms carefully before using our services." />
            
            <section className="legal-section">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="legal-card">
                                <p className="last-updated">Last Updated: October 2023</p>

                                <h3>1. Introduction</h3>
                                <p>Welcome to MediCare Plus Health Solution. These Terms and Conditions govern your use of our website and services. By accessing or using our platform, you agree to be bound by these terms.</p>

                                <h3>2. Medical Disclaimer</h3>
                                <p>The content provided on this website is for informational purposes only and is not intended as a substitute for professional medical advice, diagnosis, or treatment. Always seek the advice of your physician or other qualified health provider with any questions you may have regarding a medical condition.</p>
                                
                                <h3>3. User Accounts</h3>
                                <p>When you create an account with us, you must provide accurate, complete, and current information at all times. Failure to do so constitutes a breach of the Terms, which may result in immediate termination of your account on our service.</p>
                                <ul>
                                    <li>You are responsible for safeguarding the password that you use to access the service.</li>
                                    <li>You agree not to disclose your password to any third party.</li>
                                    <li>You must notify us immediately upon becoming aware of any breach of security or unauthorized use of your account.</li>
                                </ul>

                                <h3>4. Appointments and Cancellations</h3>
                                <p>By booking an appointment through our platform, you agree to adhere to our cancellation policy. Appointments must be canceled at least 24 hours in advance. Failure to do so may result in a cancellation fee.</p>

                                <h3>5. Intellectual Property</h3>
                                <p>The service and its original content, features, and functionality are and will remain the exclusive property of MediCare Plus Health Solution and its licensors. The service is protected by copyright, trademark, and other laws of both the country and foreign countries.</p>

                                <h3>6. Limitation of Liability</h3>
                                <p>In no event shall MediCare Plus Health Solution, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the service.</p>

                                <h3>7. Changes to Terms</h3>
                                <p>We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will try to provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion.</p>

                                <h3>8. Contact Us</h3>
                                <p>If you have any questions about these Terms, please contact us at support@medicareplus.com.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </>
    );
};

export default Terms;
